export const MASTER_DATA_DEFAULT_SHEET_NAMES = {
    INFO_SHEET: 'Infodaten',
    BALANCE_SHEET: 'Bilanz',
    INCOME_SHEET: 'GuV',
    TEMPLATE_STRUCTURE_SHEET: 'Postenstruktur',
    TEMPLATE_INFO_SHEET: 'Posteninfo',
    VERSION_SHEET: 'Version',
};
